import script from "./EditInstallmentsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInstallmentsModal.vue?vue&type=script&setup=true&lang=js"

import "./EditInstallmentsModal.vue?vue&type=style&index=0&id=52c7387e&lang=css"

const __exports__ = script;

export default __exports__